<template>
  <div data-luko-tracking="Page-Giveback">
    <GivebackModule :data="data" />
  </div>
</template>

<script>
import GivebackModule from '~/modules/Giveback'
import { formatMetaDatas } from '~/utils/metaData'

export default {
  head() {
    return formatMetaDatas(this.metaDatas, this.$route.path)
  },
  components: {
    GivebackModule,
  },
  async asyncData({ $prismic, app, store, error }) {
    try {
      const { data, alternate_languages } = await $prismic.api.getSingle(
        'giveback_page',
        {
          lang: app.i18n.localeProperties.prismicIso,
        }
      )

      store.dispatch('setAlternateLanguages', alternate_languages)

      // Extract page settings from PageSettings slice.
      store.commit(
        'page/UPDATE',
        data.body.find((s) => s.slice_type === 'page_settings')
      )
      data.body = data.body.filter((s) => s.slice_type !== 'page_settings')

      return {
        data,
        metaDatas: data.body1 || [],
      }
    } catch (e) {
      console.error(e)
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>
